// third party scope
import * as matcher from 'matcher';

export { matcher };
